import { useQuery } from '@tanstack/react-query'

import { produtosKeys } from '@/features/produtos/utils'
import { GetProdutoDisponivel } from '@/shared/services'

export const useProdutoDisponivel = (idExternoProduto: number) => {
  return useQuery({
    queryKey: produtosKeys.status(idExternoProduto),
    queryFn: async () => new GetProdutoDisponivel().execute(idExternoProduto).then((res) => res.data),
    enabled: false,
  })
}
